import React from 'react';
import classnames from 'classnames';
import HiddenIcon from '@wix/da-ds/pkg/Icons/Hidden';
import { IconSize } from '@wix/da-ds/pkg/Icons/IconWrap';
import Flex from '@wix/da-ds/pkg/Flex';
import s from './Hidden.scss';
const HiddenDumbView = ({ className, width, height })=>{
    const canShowHugeIcon = Math.min(width !== null && width !== void 0 ? width : Infinity, height !== null && height !== void 0 ? height : Infinity) > 48;
    return /*#__PURE__*/ React.createElement(Flex, {
        className: classnames(s['root'], className),
        justifyContent: "center",
        alignItems: "center",
        style: {
            width: width || height,
            height: height || width
        }
    }, /*#__PURE__*/ React.createElement(HiddenIcon, {
        size: canShowHugeIcon ? IconSize.HUGE : IconSize.SMALL
    }));
};
HiddenDumbView.displayName = 'HiddenDumbView';
export default HiddenDumbView;

//# sourceMappingURL=Hidden.js.map